<template lang="pug">
    .page
        //- Create Modal
        a-modal(v-model="addVisible" 
            title="创建交易账号" 
            @ok="handleCreateOk" 
            ok-text="创建"
            cancel-text="取消")
            a-form-model(:model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }")
                a-form-model-item(label="Name")
                    a-input(v-model="form.name")
                a-form-model-item(label="Account")
                    a-input(v-model="form.account")
                a-form-model-item(label="Account Type")
                    a-select(v-model="form.accountType")
                        a-select-option(value="stock_cn") 股票(中国)
                        a-select-option(value="futures_cn") 期货(中国)
                        
                a-form-model-item(label="Broker")
                    a-input(v-model="form.broker")
                a-form-model-item(label="Host")
                    a-input(v-model="form.host")
                a-form-model-item(label="ClientId")
                    a-input(v-model="form.clientId")
                a-form-model-item(label="Desc")
                    a-input(v-model="form.desc")

        //- Edit Drawer
        a-drawer(:visible="editVisible" 
            title="编辑交易账号" 
            width="500"
            @close="editVisible=false"
        )
            a-form-model(:model="editForm" layout="vertical")
                a-form-model-item(label="Name")
                    a-input(v-model="editForm.name")
                a-form-model-item(label="Account")
                    a-input(v-model="editForm.account")
                a-form-model-item(label="Account Type")
                    a-select(v-model="editForm.accountType")
                        a-select-option(value="stock_cn") 股票(中国)
                        a-select-option(value="futures_cn") 期货(中国)
                a-form-model-item(label="Broker")
                    a-input(v-model="editForm.broker")
                a-form-model-item(label="Desc")
                    a-input(v-model="editForm.desc")
            
            a-button(type="primary" style="margin-top:20px" @click="submitEdit") 保存修改

        .ctl-bar
            a-button(type="primary" 
                @click="handleCreate" 
                style=" margin-right:20px") 
                a-icon(type="plus")
                span 创建

            a-button(type="primary"
                style=" margin-right:20px"
                @click="getData")
                a-icon(type="redo")
                span 刷新

            //- 新增：视图切换按钮组
            a-radio-group(v-model="viewMode" button-style="solid" style="margin-right:20px")
                a-radio-button(value="table")
                    a-icon(type="table")
                    span 表格视图
                a-radio-button(value="card")
                    a-icon(type="appstore-o")
                    span 卡片视图

            //- 新增：Host筛选下拉框
            a-select(v-model="selectedHost" placeholder="选择Host筛选" style="width:250px" @change="handleHostFilterChange")
                a-select-option(v-for="option in hostOptions" :key="option.value" :value="option.value") {{ option.label }}

        a-table(:columns="columns",
            size="small"
            :dataSource="items"
            :pagination="{ pageSize: 50 }"
            rowKey="_id"
            v-if="viewMode === 'table'")
            template(slot="accountType" slot-scope="text")
                span {{ text === 'stock_cn' ? '股票(中国)' : (text ==='futures_cn' ? '期货(中国)' : text) }}

            template(slot="action" slot-scope="record")
                a-popconfirm(title="确认删除该账号吗？"
                    ok-text="确认"
                    cancel-text="取消"
                    @confirm="submitDelete(record._id)")
                    a.red
                        a-icon(type="delete")
                a-divider(type="vertical")
                a(@click="handleEdit(record)")
                    a-icon(type="edit")
                a-divider(type="vertical")
                a(@click="handleCreateFrom(record)")
                    a-icon(type="plus")

            template(slot="expandedRowRender" slot-scope="record")
                TradeAccountUser(:id="record._id")

        //- 新增：卡片视图（条件渲染）
        div(v-if="viewMode === 'card'" class="card-view-container")
            a-row(:gutter="16")
                a-col(:xs="24" :sm="24" :md="24" :lg="24" :xl="12" v-for="group in groupedByHost" :key="group.host" style="margin-bottom:24px")
                    a-card(hoverable :bordered="false")
                        // Host分组卡片头部
                        div(slot="title" class="host-card-header")
                            span(class="host-name") {{ group.host }} 
                            a-tag(color="blue" style="margin-left:12px") {{ group.items.length }} 个账号
                            span Account {{group.account}}
                            a-divider(type="vertical")
                            span {{group.accountType}}

                        div(class="card-content")
                            a-table(
                                size="small"
                                :pagination="false"
                                :data-source="group.items"
                                :columns="hostColumns")
                                        

</template>

<script>
import TradeAccountUser from './TradeAccountUser.vue';

export default {
    data() {
        return {
            addVisible: false,
            editVisible: false,
            // 视图模式
            viewMode: localStorage.getItem('tradeAccountViewMode') || 'table', // 'table' | 'card'
            // 选中的Host筛选值
            selectedHost: '',
            // 常量定义
            UNCLASSIFIED_HOST: '未分类',

            form: {
                name: '',
                account: '',
                accountType: 'stock_cn',
                broker: '',
                host: '',
                clientId: '',
                desc: ''
            },
            
            editForm: {
                _id: '',
                name: '',
                account: '',
                broker: '',
                accountType: '',
            },

            columns: [
                {
                    title: 'ID',
                    dataIndex: '_id',
                },
                {
                    title: 'Name',
                    dataIndex: 'name',
                    sorter: (a, b) => a.name.localeCompare(b.name),
                },
                {
                    title: 'Account',
                    dataIndex: 'account',
                    sorter: (a, b) => (a.account || '').localeCompare(b.account || ''),
                },
                {
                    title: 'Account Type',
                    dataIndex: 'accountType',
                    sorter: (a, b) => (a.accountType || '').localeCompare(b.accountType || ''),
                    scopedSlots: { customRender: 'accountType' }
                },
                {
                    title: 'Broker',
                    dataIndex: 'broker',
                },
                {
                    title: 'Host',
                    dataIndex: 'host',
                },
                {
                    title: 'ClientId',
                    dataIndex: 'clientId',
                },
                // {
                //     title: 'Desc',
                //     dataIndex: 'desc',
                // },
                {
                    title: 'User Count',
                    dataIndex: 'userCount',
                    sorter: (a, b) => a.userCount - b.userCount,
                },
                {
                    title: 'Created At',
                    dataIndex: 'createdAt',
                    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
                },
                {
                    title: 'Action',
                    scopedSlots: { customRender: 'action' },
                }
            ],
            hostColumns: [
                {
                    title: 'Name',
                    dataIndex: 'name',
                    sorter: (a, b) => a.name.localeCompare(b.name),
                },
                
                
                {
                    title: 'ClientId',
                    dataIndex: 'clientId',
                },
                {
                    title: 'User Count',
                    dataIndex: 'userCount',
                    sorter: (a, b) => a.userCount - b.userCount,
                },
                {
                    title: 'Created At',
                    dataIndex: 'createdAt',
                    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
                },
                {
                    title: 'Action',
                    scopedSlots: { customRender: 'action' },
                }
            ],
            items: [],
            users: []
        };
    },
    computed: {
        // 按Host分组的账号列表
        groupedByHost() {
            // 先应用Host筛选
            const filteredItems = this.selectedHost
                ? this.items.filter(item => (item.host || this.UNCLASSIFIED_HOST) === this.selectedHost)
                : this.items;

            const groups = {};
            const groupAccounts = {};
            const groupAccountTypes = {};
            filteredItems.forEach(item => {
                const host = item.host || this.UNCLASSIFIED_HOST;
                if (!groups[host]) {
                    groups[host] = [];
                }
                groups[host].push(item);
                groupAccountTypes[host] = item.accountType;
                groupAccounts[host] = item.account;
            });

            // 按Host名称排序
            return Object.keys(groups).sort().map(host => ({
                host,
                account: groupAccounts[host],
                items: groups[host],
                accountType: groupAccountTypes[host],
            }));
        },
        // Host筛选下拉框选项
        hostOptions() {
            const hosts = [...new Set(this.items.map(item => item.host).filter(Boolean))];
            return [
                { value: '', label: '全部Host' },
                ...hosts.sort().map(host => ({ value: host, label: host }))
            ];
        }
    },
    watch: {
        viewMode(newVal) {
            localStorage.setItem('tradeAccountViewMode', newVal);
        }
    },
    mounted() {
        this.getUsers();
        this.getData();
    },
    methods: {
        getUserName(id) {
             const u = this.users.find(u => u._id === id);
             return u ? u.name : id;
        },
        handleCreate() {
            this.form = {
                name: '',
                account: '',
                accountType: 'stock_cn',
                broker: '',
                host: '',
                clientId: '',
                desc: ''
            };
            this.addVisible = true;
        },
        handleCreateOk() {
            this.$api.request('POST', 'tradeAccount/create', this.form)
            .then(res => {
                this.$message.success('创建成功');
                this.addVisible = false;
                this.getData();
            });
        },
        handleCreateFrom(record) {
            this.form = {
                name: record.name || '',
                account: record.account || '',
                accountType: record.accountType || 'stock_cn',
                broker: record.broker || '',
                host: record.host || '',
                clientId: record.clientId || '',
                desc: record.desc || ''
            };
            this.addVisible = true;
        },
        handleEdit(record) {
            this.editForm = { ...record };
            this.editVisible = true;
        },
        submitEdit() {
            this.$api.request('POST', `tradeAccount/update`, this.editForm)
            .then(res => {
                this.$message.success('更新成功');
                this.editVisible = false;
                this.getData();
            });
        },
        submitDelete(id) {
            this.$api.request('DELETE', `tradeAccount/${id}`)
            .then(res => {
                this.$message.success('删除成功');
                this.getData();
            })
        },
        getData() {
            this.$api.request('GET', 'tradeAccounts')
            .then(res => {
                this.items = res.data.map(item => ({
                    ...item,
                    createdAt: new Date(item.createdAt).toLocaleString(),
                }));
            })
        },
        getUsers() {
            this.$api.request("GET", 'users')
            .then(res => {
                this.users = res.data;
            });
        },
        handleHostFilterChange(value) {
            // Host筛选值变化时触发
            // 后续可以在这里添加统计、日志等扩展功能
            console.log('Host筛选已变更为:', value || '全部');
        }
    },
    components: {
        TradeAccountUser
    }
};
</script>

<style lang="less" scoped>
.ctl-bar {
    margin-bottom: 20px;
}
.user-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    div {
        background: #f0f0f0;
        padding: 5px 10px;
        border-radius: 4px;
        margin-bottom: 5px;
    }
}
.red {
    color: red;
}

// 新增卡片视图样式
.card-view-container {
    .host-card-header {
        display: flex;
        align-items: center;
        .host-name {
            font-size: 16px;
            font-weight: 600;
        }
    }

    .account-card {
        height: 100%;
        .card-actions {
            a {
                cursor: pointer;
                &:hover {
                    opacity: 0.7;
                }
            }
        }

        .card-content {
            .info-item {
                padding: 6px 0;
                font-size: 13px;
                line-height: 1.5;
                border-bottom: 1px solid #f0f0f0;

                &:last-child {
                    border-bottom: none;
                }

                .label {
                    color: #666;
                    font-weight: 500;
                    margin-right: 8px;
                    display: inline-block;
                }

                .value {
                    color: #333;
                    word-break: break-all;
                }
            }
        }
    }
}
</style>